/**
 * Function to run GET request easily.
 *
 * @param url
 * @param self
 * @returns {Promise<unknown>}
 */
window.runGetReq = function (url, self = false) {
    return new Promise(function (resolve, reject) {
        let req = new XMLHttpRequest();
        req.withCredentials = false;

        if (self) {
            req.open("GET", url);
        } else {
            req.open("GET", __API + url);
        }


        req.onload = function () {
            if (req.status === 200) {
                resolve(req.response);
            } else {
                reject(req.response);
            }
        };
        req.onerror = function (e) {
            reject(Error("Network Error"));
        };
        req.send();
    });
}

/**
 * Function to run POST request easily.
 *
 * @param url
 * @param dataIn
 * @param dataHeader
 * @param self
 * @returns {Promise<unknown>}
 */
window.runPostReq = function (url, dataIn, dataHeader, self = false) {
    return new Promise(function (resolve, reject) {
        let req = new XMLHttpRequest();
        let data = dataHeader + dataIn;


        req.withCredentials = false;

        if (!self) {
            req.open("POST", env + url);
        } else {
            req.open("POST", url);
        }
        req.setRequestHeader("content-type", "application/x-www-form-urlencoded");


        req.onload = function () {
            if (req.status === 200) {
                resolve(req.response);
            } else {
                reject(req.response);
            }
        };

        req.onerror = function () {
            reject(Error("Network Error"));
        };
        req.send(data);
    });
}

window.setIconImageFallback = function(img) {
    img.src = 'https://www.binge.nl/static/img/logo/Binge-appicon01.png'
}

/**
 * Get UTM source from string.
 *
 * @returns {string}
 */
window.getUtmSourceValue = function() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('utm_source');
}

/**
 * Function to set and/or obtain the utm source from the URL.
 *
 * @returns {string}
 */
window.getUtmSource = function() {
    let currSessionObj = sessionStorage.getItem('sessionObject');
    const utmSourceFromUrl = getUtmSourceValue();

    /**
     * The following check checks if we have a local session object.
     * If so: check if we have an utm source set. If this is true, check if it's at least the same as the one saved. Otherwise, we want the new one.
     * If not: check if the expiry time is not expired, otherwise we obtain a new one or set an empty one.
     */
    if (currSessionObj !== null) {
        currSessionObj = JSON.parse(currSessionObj);
        if (currSessionObj.hasOwnProperty('expiresAt') && currSessionObj.hasOwnProperty('utmSource')) {
            if (utmSourceFromUrl !== null && utmSourceFromUrl !== '') {
                if (currSessionObj['expiresAt'] > new Date().getTime() && currSessionObj['utmSource'] === utmSourceFromUrl) {
                    return currSessionObj['utmSource'];
                }
            } else if (currSessionObj['expiresAt'] > new Date().getTime()) {
                return currSessionObj['utmSource'];
            } else { // nothing will result in true, so we remove the object from session storage.
                sessionStorage.removeItem('sessionObject');
            }
        }
    }

    // Set the utm source object.
    if (utmSourceFromUrl !== null && utmSourceFromUrl !== '') {
        const dateToExpire = new Date().getTime() + (30 * 60 * 1000);
        let sessionObject = {
            expiresAt: dateToExpire,
            utmSource: utmSourceFromUrl
        }
        sessionStorage.setItem('sessionObject', JSON.stringify(sessionObject));
        return utmSourceFromUrl;
    }

    return '';
}

/**
 * Set the UTM source saved in session object.
 *
 */
window.setUtmSource = function() {
    const utmSource = getUtmSource();
    const appStoreLinks = document.querySelectorAll('.app_store_link');

    if (utmSource !== '' && appStoreLinks) {
        appStoreLinks.forEach((link) => {
            if (link.classList.contains('play-store-btn')) {
                link.href = updateURLParameter(link.href, 'referrer', 'utm_source%3D' + utmSource);
            } else if (link.classList.contains('app-store-btn')) {
                link.href = updateURLParameter(link.href, 'ct', utmSource);
            }
        });
    }
}

/**
 * Determine the mobile operating system.
 * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
 *
 * @returns {String}
 */
function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
    }
    if (/android/i.test(userAgent)) {
        return "Android";
    }
    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
    }
    return "unknown";
}

window.openDefaultAppStore = function() {
    switch (getMobileOperatingSystem()) {
        default:
        case 'Android':
            window.open('https://play.google.com/store/apps/details?id=nl.bindinc.binge&referrer=utm_source%3Dbinge.nl');
            break;
        case 'iOS':
            window.open('https://apps.apple.com/app/apple-store/id6449541074?pt=126391779&ct=binge.nl&mt=8');
            break;
    }
}

// Set detected os on body element
$(document).ready(function () {
    let body = document.body;
    body.classList.add("os-" + (getMobileOperatingSystem().replace(' ', '-').toLowerCase()));
});

/**
 * Function to replace url parameter.
 *
 * @param url
 * @param param
 * @param paramVal
 * @returns {string}
 */
function updateURLParameter(url, param, paramVal) {
    let newAdditionalURL = '';
    let tempArray = url.split('?');
    let baseURL = tempArray[0];
    let additionalURL = tempArray[1];
    let temp = '';
    if (additionalURL) {
        tempArray = additionalURL.split('&');
        for (let i = 0; i < tempArray.length; i++) {
            if (tempArray[i].split('=')[0] !== param) {
                newAdditionalURL += temp + tempArray[i];
                temp = '&';
            }
        }
    }
    let rows_txt = temp + '' + param + '=' + paramVal;
    return baseURL + '?' + newAdditionalURL + rows_txt;
}

